import { skipToken } from "@tanstack/react-query";
import { trpc } from "../../main/components/trpc.ts";
import _ from "underts";
import { messagesToThreadsPipeline } from "../filterTransform/messagesToThreadPipeline";
import useUser from "../../users/hooks/useUser";
import useAllUsers from "../../users/hooks/useAllUsers";
import Thread from "./Thread";
import styles from "./PatientMessagesMainComp.module.css";
import useSelectedPatients from "../../patients/hooks/useSelectedPatients";

const PatientMessagesMainComp = () => {
  const user = useUser();
  const allUsers = useAllUsers();

  const patient = _.first(useSelectedPatients()) || null;
  const patientId = patient ? patient.id : null;
  const messages =
    trpc.message.getAllMessagesForPatient.useQuery(
      patientId ? patientId : skipToken
    ).data ?? [];
  const messagesWithPatientsNames = messages.map((msg) => {
    return {
      ...msg,
      name: patient?.name || "",
      forename: patient?.forename || "",
    };
  });
  const threads = user
    ? messagesToThreadsPipeline(messagesWithPatientsNames, user, allUsers)
    : [];

  return (
    <div className={styles.threadsSpacer}>
      {threads.map((thread) => {
        const thread_id = _.first(thread)?.thread_id;
        if (!thread_id) {
          throw new Error("Thread id is missing");
        }
        return (
          <Thread
            key={thread[0].thread_id}
            threadId={thread_id}
            messages={thread}
            isDoctor={false}
            onArchiveClick={() => {}}
            isResponding={false}
            onMessageClick={() => {}}
            onReplyClick={() => {}}
            replyText={""}
            name={""}
            firstName={""}
            msgReplyType={"info"}
            onReplySend={() => {}}
            onReplyTextChange={() => {}}
            onReplyCancel={() => {}}
            onEmergencyClick={() => {}}
            onQuestionClick={() => {}}
            onCallClick={() => {}}
            onWaitingClick={() => {}}
            onDoneClick={() => {}}
            onSelectPatientForMessage={() => {}}
            onSelectPatient={() => {}}
            onRespondReplayClick={() => {}}
            showReplyLink={false}
          />
        );
      })}
    </div>
  );
};

export default PatientMessagesMainComp;
